module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rbook"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/Book#book"
    }
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rint"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Introduction#int"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "rpt1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Part001#pt1"
    }
  }, [_vm._v("Part I:")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spacep"
  }, [_c('a', {
    attrs: {
      "href": "#/Part001#pt1"
    }
  }, [_c('b', [_vm._v("BEFORE YOU BEGIN")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter001#ch1"
    }
  }, [_c('b', [_vm._v("Chapter 1")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter001#ch1"
    }
  }, [_vm._v("You Are What You Eat")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter002#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 2")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter002#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foods to Avoid and Their Alternatives")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 3")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everyday Foods for Beautiful Skin")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 4")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food Combining & Foods to Enjoy")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 5")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supplemental Practices")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part2",
    attrs: {
      "id": "rpt2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part002#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II:")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    attrs: {
      "href": "#/Part002#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CLEAR SKIN DETOX DIET")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 6")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your New Diet Lifestyle for a Glowing Complexion")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 7")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frequently Asked Questions")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 8")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glow Detox Recipes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 9")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Skincare Regimen Recommendations")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 10")])]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "space1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry-ts",
    attrs: {
      "id": "rapp"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Appendix#app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "raut"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Author#aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0